module.exports = "<div class=\"row\">\n  <div class=\"col-md-2\">\n    <nv-spine-button [document]=\"document\"></nv-spine-button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/app/components/nv-render/nv-render.component.html
// module id = ../../../../../src/app/components/nv-render/nv-render.component.html
// module chunks = 0